export const USER_TOKEN = "user_token";
export const PHONE_NUMBER = "phone_number";
export const USER_PROFILE = "user_profile";